import _suggestWarningFill from "@zenlayer/zen-design-icons/assets/suggest/WarningFill.svg";
import _suggestNoticeCircleFill from "@zenlayer/zen-design-icons/assets/suggest/NoticeCircleFill.svg";
import _suggestCheckCircleFill from "@zenlayer/zen-design-icons/assets/suggest/CheckCircleFill.svg";
import classnames from 'classnames';
import * as React from 'react';
import Icon from '../icon';
import Space from '../space';
import Tooltip from '../tooltip';
import Typography from '../typography';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const States = props => {
  const {
    size = 'm',
    icon,
    status,
    pointColor,
    pointClassName,
    tooltip,
    block,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-state");
  const showPoint = !!pointColor || !!pointClassName || !!status;
  return /*#__PURE__*/_jsx("div", {
    ...restProps,
    className: classnames(baseClassName, "".concat(baseClassName, "--").concat(showPoint && !icon ? 'm' : size), {
      ["".concat(baseClassName, "--icon")]: !!icon,
      ["".concat(baseClassName, "--").concat(status)]: !!status,
      ['block']: !!block
    }, className),
    style: style,
    children: /*#__PURE__*/_jsx(Tooltip, {
      title: tooltip,
      children: /*#__PURE__*/_jsxs("div", {
        className: "".concat(baseClassName, "--inner"),
        children: [!!icon && /*#__PURE__*/React.cloneElement(icon), showPoint && /*#__PURE__*/_jsx("div", {
          className: classnames('point', pointClassName),
          style: {
            backgroundColor: pointColor
          }
        })]
      })
    })
  });
};
const StatesIcon = props => {
  const {
    text,
    status,
    size,
    block,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-stateIcon");
  const icon = React.useMemo(() => {
    if (status === 'success') {
      return /*#__PURE__*/_jsx(Icon, {
        type: "suggest/CheckCircleFill",
        block: true,
        className: "icon"
      });
    } else if (status === 'error') {
      return /*#__PURE__*/_jsx(Icon, {
        type: "suggest/NoticeCircleFill",
        block: true,
        className: "icon"
      });
    } else if (status === 'warning') {
      return /*#__PURE__*/_jsx(Icon, {
        type: "suggest/WarningFill",
        block: true,
        className: "icon"
      });
    }
    return /*#__PURE__*/_jsx(States, {
      status: status,
      block: true
    });
  }, [status]);
  const _size = size || '14-20';
  const [fontSize, lineHeight] = _size.split('-');
  return /*#__PURE__*/_jsxs(Space, {
    ...restProps,
    size: 4,
    block: block,
    className: classnames(baseClassName, className, status),
    style: style,
    children: [/*#__PURE__*/_jsx("div", {
      className: "".concat(baseClassName, "-prefix"),
      style: {
        fontSize: "".concat(fontSize, "px"),
        height: "".concat(lineHeight, "px")
      },
      children: icon
    }), /*#__PURE__*/_jsx(Typography.Text, {
      size: _size,
      children: text
    })]
  });
};
States.StatesIcon = StatesIcon;
export default States;